import { createSlice } from "@reduxjs/toolkit";

const initialState={
    isVoiceNavigationActive:false,
    isDictionaryActive:false,
    isPageStructureActive:false,
}

const booleanSlice=createSlice({
    name:"boolean",
    initialState,
    reducers:{
        setVoiceNavigationActive(state, action){
            state.isVoiceNavigationActive = action.payload;
            // if(action.payload === true){
            //     state.isDictionaryActive = false;
            // }
        },
        setDictionaryActive(state, action){
            state.isDictionaryActive = action.payload;
            // if(action.payload === true){
            //     state.isVoiceNavigationActive = false;
            // }
        },
        setPageStructureActive(state, action){
            console.log(action.payload, "action.payload");
            state.isPageStructureActive = action.payload;
        },
    },
});

export const {setVoiceNavigationActive,setDictionaryActive,setPageStructureActive}=booleanSlice.actions;
export const selectIsVoiceNavigationActive= (state) => state.boolean.isVoiceNavigationActive;
export const selectIsDictionaryActive= (state) => state.boolean.isDictionaryActive;
export const selectIsPageStructureActive= (state) => state.boolean.isPageStructureActive;
export default booleanSlice.reducer;